import { RecursivePartial } from 'typings/utilsTypes';
import create from 'zustand';
import { persist } from 'zustand/middleware';
import { getFormula } from '../api/config';
import { VirtualFormulaResponse } from '../types/api/formula';

interface State {
  formula: RecursivePartial<VirtualFormulaResponse>;
}

interface Actions {
  loadFormula(): Promise<VirtualFormulaResponse>;
}

const initialState: State = {
  formula: {},
};

export const useFormulaStore = create(
  persist<State & Actions>(
    (set) => ({
      ...initialState,
      loadFormula: async () => {
        try {
          const { data: axiosData } = await getFormula();
          const { data } = axiosData;

          set({ formula: data });

          return data;
        } catch (e) {
          return Promise.reject(e);
        }
      },
    }),
    {
      name: 'virtualFormula',
    },
  ),
);

export default useFormulaStore;
